import { BusClockIcon } from './BusClockIcon';

/**
 * author: Google
 * id B37694EA-F48B-4F48-ACF1-0E48FB334473
 * name bus-clock
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bus-clock.svg
 * tags
 * - Date / Time 
 * - Transportation + Road 
 */
export const DepartureBoardIcon = BusClockIcon;
export default DepartureBoardIcon